import React from 'react';
import { TEXT_KEYS } from '../../../constants/textKeys';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { t } from '../../../translation/translation';
import { Button } from '../Button';
import IconContainer from '../IconContainer';
import './style.css'

type TTitleWithIconProps = {
    imagePath?: string;
    firstTitlePart?: JSX.Element | string;
    secondTitlePart?: JSX.Element | string;
    thirdTitlePart?: JSX.Element | string;
    isIconContainer?: boolean
    isButtonBottom?: boolean
    onClickButtonLeft?: () => void;
    onClickButtonRight?: () => void;
    
}

export const TitleWithIcon = ({
    imagePath = '',
    firstTitlePart = '' as JSX.Element | string,
    secondTitlePart = '' as JSX.Element | string,
    thirdTitlePart = '' as JSX.Element | string,
    isIconContainer = true,
    isButtonBottom = false,
    onClickButtonLeft = () => null,
    onClickButtonRight = () => null,
}: TTitleWithIconProps) => {

    const isMobile = useIsMobile()

    return (
        <div className='title-icon-container section'>
            <div className='title-icon-title-part-1'>
                <h1>{firstTitlePart}</h1>
                {!isIconContainer && imagePath ?
                    <img src={imagePath} className={isMobile ? 'raw-image-mobile' : 'raw-image'} />
                    : isIconContainer && imagePath ?
                        <IconContainer image_path={imagePath} />
                        :
                        null
                }

                <h1>{secondTitlePart}</h1>
            </div>
            <div className='title-icon-title-part-2'>
                <h1>{thirdTitlePart}</h1>
            </div>
            {isButtonBottom ?
                <div className='support-button-navigation-container'>
                    <div>
                        <Button
                            label={t(TEXT_KEYS.SUPPORT_MAIN_BUTTON_1)}
                            onClick={onClickButtonLeft}
                        />
                    </div>
                    <div>
                        <Button
                            label={t(TEXT_KEYS.SUPPORT_MAIN_BUTTON_2)}
                            onClick={onClickButtonRight}
                        />
                    </div>
                </div>
                : null}
        </div>
    )
}

export default TitleWithIcon